
import type { AsyncDataOptions } from '#app';
import type { FetchOptions } from 'ofetch';
import FetchFactory from '../factory';


class SocialModule extends FetchFactory<ISocial> {
  private RESOURCE = '/social';

  async socialAccountsMe(
    fetchOptions?: FetchOptions<'json', string>,
    asyncDataOptions?: AsyncDataOptions<FetchResponse<ISocial[]>>
  ) {
    return useAsyncData(
      () => {
        return this.call(
          `${this.RESOURCE}/accounts/me`,
          fetchOptions
        )
      },
      asyncDataOptions
    )
  };

}

export default SocialModule;

